'use client';

import { useState, useEffect } from 'react';
import Tabs from './components/Tabs/Tabs';
import { JetCatalogData, TabValues } from '@/types/jetCatalog.types';
import Card from './components/Card/Card';
import { motion, AnimatePresence } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import styles from './jetCatalog.module.scss';

const JetCatalog = ({ jetCatalogData }: JetCatalogData) => {
  const [activeTab, setActiveTab] = useState<TabValues>(TabValues.ALL_JETS);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);

    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  const filteredJets = jetCatalogData.filter((jet) => {
    if (activeTab === TabValues.ALL_JETS) {
      return true;
    }
    return jet.category === activeTab;
  });

  return (
    <section className={styles.jetCatalogSection}>
      <div className="container">
        <div className={styles.jetCatalog}>
          <Tabs activeTab={activeTab} onTabChange={setActiveTab} />
        </div>
        {isMobile ? (
          <div className={styles.jetCatalogSwiper}>
            <style jsx global>{`
              .swiper-pagination {
                position: absolute;
                bottom: 2px !important;
                left: 0;
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
              }
              .swiper-pagination-bullet {
                width: 19px;
                height: 4px;
                background: #d9d9d9;
                opacity: 1;
                margin: 0 6px;
                cursor: pointer;
                border-radius: 6px;
              }
              .swiper-pagination-bullet-active {
                background: #4d535f;
                width: 48px;
                height: 4px;
              }
            `}</style>
            <Swiper
              modules={[Pagination]}
              spaceBetween={16}
              slidesPerView={1}
              pagination={{
                clickable: true,
              }}
            >
              {filteredJets.map((jet) => (
                <SwiperSlide key={jet.id}>
                  <Card jet={jet} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        ) : (
          <motion.div
            className={styles.jetCatalogItems}
            initial="initial"
            animate="animate"
            exit="exit"
            variants={{
              animate: {
                transition: {
                  staggerChildren: 0.1,
                },
              },
            }}
          >
            <AnimatePresence mode="wait">
              {filteredJets.map((jet) => (
                <Card key={jet.id} jet={jet} />
              ))}
            </AnimatePresence>
          </motion.div>
        )}
      </div>
    </section>
  );
};

export default JetCatalog;
